import { I18nMessages } from '../../../../../libs/IdeLink.Web.Common/src/services/i18n/I18nMessages';

export const frEntities: I18nMessages = {
    'entities.list.pageTitle': 'Entités',

    //* Entities >> LIST
    'entities.list.sectionTitle': 'Entités',
    'entities.list.emptyLabel': 'Aucune entité pour le moment.',
    'entities.list.actions.addGroup': 'Ajouter une entité',
    'entities.list.actions.importExcel': 'Import Excel',
    'entities.list.actions.exportExcel': 'Export Excel',
    'entities.list.item.floatingLabelTitle': 'Nom',
    'entities.list.item.floatingLabelCode': 'Code',
    'entities.list.item.floatingLabelPath': 'Chemin',
    'entities.list.item.floatingLabelParentName': 'Pays parent',

    //* Entities >> DETAILS
    'entities.details.pageTitle': 'Détails entité',
    'entities.details.detailsInfo':
        'Pas de zone enfant pour le moment. Pour en ajouter, rendez-vous dans l’onglet « Zones » où vous pourrez affecter des entités parentes.',
    'entities.details.actions.save': 'Enregistrer',
    'entities.details.actions.removeZone': "Supprimer l'entité",
    'entities.details.actions.disabledRemoveInfo':
        'Cette entité contient des zones et ne peut être supprimée.',
    'entities.details.actions.previous': 'Entités',
    'entities.details.dialog.title': "Suppression d'entité",
    'entities.details.dialog.content': 'Êtes-vous sûr de vouloir supprimer cette entité ?',
    'entities.details.dialog.validateLabel': 'Supprimer',
    'entities.details.dialog.cancelLabel': 'Annuler',
    'entities.details.input.name': "Saisissez ici le nom de l'Entité *",
    'entities.details.input.code': "Saisissez ici le code de l'Entité *",
    'entities.details.input.floatingLabelName': 'Nom',
    'entities.details.input.floatingLabelCode': 'Code',
    'entities.details.item.floatingLabelTitle': 'Nom',
    'entities.details.item.floatingLabelCode': 'Code',

    //* Entities >> CREATE
    'entities.create.pageTitle': 'Création entité',
    'entities.details.sectionTitle': 'LISTE ZONES ENFANTS',
    'entities.create.createInfo':
        'Pas de zone enfant pour le moment. Pour en ajouter, rendez-vous dans l’onglet « Zones » où vous pourrez affecter des entités parentes.',
    'entities.create.actions.cancelCreation': 'Annuler la création',
    'entities.create.actions.addTheArea': 'Enregistrer',
    'entities.create.input.name': "Saisissez ici le nom de l'Entité *",
    'entities.create.input.code': "Saisissez ici le code de l'Entité *",
    'entities.create.input.floatingLabelName': 'Nom',
    'entities.create.input.floatingLabelCode': 'Code',
    'entities.create.select.title': 'Pays parent',
    'entities.create.select.label': 'Pays parent',
    'entities.create.select.placeholder': 'Sélectionnez un pays parent',
    'entities.create.select.listTitle': 'Choix du pays parent',
    'entities.create.select.listInputLabel': 'Chercher un pays',
    'entities.create.select.listCloseLabel': 'Fermer',

    'entities.import.success': 'Bravo! Entités importés avec succès',
};
